import { render, staticRenderFns } from "./AppButtonTextLink.vue?vue&type=template&id=c8f53264&scoped=true"
import script from "./AppButtonTextLink.vue?vue&type=script&lang=js"
export * from "./AppButtonTextLink.vue?vue&type=script&lang=js"
import style0 from "./AppButtonTextLink.vue?vue&type=style&index=0&id=c8f53264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f53264",
  null
  
)

export default component.exports